import * as md5 from 'md5';
// this is needed to support jest's loading of the module using commonjs while esModuleInterop is enabled in quantum-product.
var exportFn = md5.default || md5;
export default exportFn;
